function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#202124",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M13.541 3.77c.438-.103.895.044 1.19.38l7.304 7.249c.234.224.367.534.367.858 0 .324-.133.634-.36.852l-7.332 7.277c-.227.225-.534.351-.854.351-.32 0-.627-.126-.861-.36-.454-.47-.454-1.215.008-1.695l5.256-5.212H2.552c-.644-.034-1.15-.563-1.15-1.206s.506-1.172 1.176-1.206h15.684l-5.218-5.189c-.353-.292-.51-.759-.404-1.204.106-.445.455-.791.901-.896z",
  transform: "translate(-24 -24) translate(24 24) rotate(180 11.902 12.237)"
}))));

var SvgIconBack2 = function SvgIconBack2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconBack2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-back-2.8a6269b9.svg";
export { ForwardRef as ReactComponent };